import { Component, OnInit, Inject, ViewChild, ElementRef, AfterViewInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { TechDialogComponent } from '../tech-dialog/tech-dialog.component';
import { LanguageService } from '../../shared/services/language.service';
import { FormBuilder, FormControl, Validators } from '@angular/forms';
import { GCMService } from '../../shared/services/gcm.service';
import { TechnologiesManagementService } from '../../shared/services/technologiesManagement.service';
import { catchError, delay, retryWhen, scan } from 'rxjs/operators';
import { throwError } from 'rxjs';
import { Catalog } from 'src/app/models/Catalog';
import { CatalogService } from '../../shared/services/catalog.service';
import { InfoBarWithStatusService } from '../../shared/services/info-bar-with-status.service';
import { getCatalogErrorMessages } from 'src/app/constants/catalog-error-messages';


@Component({
  standalone: false,
  selector: 'app-edit-name-dialog',
  templateUrl: './edit-name-dialog.component.html',
  styleUrls: ['./edit-name-dialog.component.css']
})
export class EditNameDialogComponent implements OnInit {

  variables: any;
  technologyTech: string = "";
  technologyName: string = "";
  technologyRegion: string = "";
  local_data: any;
  invalidInput: boolean = false;
  invalidInput1: boolean = false;
  invalidInput2: boolean = false;
  invalidInput3: boolean = false;
  invalidInput4: boolean = false;

  errorMessage = "";
  errorMessage1 = "";
  errorMessage2 = "";
  errorMessage3 = ""
  errorMessage4 = "";
  alreadyExist: any;
  allTechs: any = [];
  allCatalogs: any = [];
  formGroup: any;
  validForm: boolean = true;

  regions: any = [];

  cecos: any = [];
  costCenters: any = [];
  filteredCostCenters: any[] = [];

  errorDetected: boolean = false;
  errorText: string = "";
  isLoadingTechs: boolean = true;
  isLoadingCatalogs: boolean = true;

  errorMessages: any;



  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<TechDialogComponent>,
    private languageService: LanguageService,
    private _formBuilder: FormBuilder,
    private infoBar: InfoBarWithStatusService,
    private GCMService: GCMService,
    private TechnologiesManagementService: TechnologiesManagementService,
    private catalogsService: CatalogService
  ) {
    this.local_data = { data };
  }


  ngOnInit() {
    this.languageService.translations$.subscribe((vars: any) => {
      this.variables = vars;
    });

    this.getAllActiveTechs();

    /*this.GCMService.getAllCECOS().subscribe((response:any) => {
      if(response) {
        this.cecos = response;
        this.cecos.forEach((ceco: any) => {
          this.costCenters.push(ceco.costCenter);
        });
        this.filteredCostCenters = this.costCenters;
        this.filteredCostCenters.sort((a, b) => {
          return a.localeCompare(b);
        });
      }
    })*/


    /*this.technologyTech = this.data.tech;
    this.technologyName = this.data.name;
    this.technologyRegion = this.data.region;
    this.regions = this.data.regions;
    this.allTechs = this.data.allTechs;
    
    this.allTechs.sort((a: any, b: any) => {
      const nameA = a.name.toLowerCase();
      const nameB = b.name.toLowerCase();
      if (nameA < nameB) {
          return -1;
      }
      if (nameA > nameB) {
          return 1;
      }
      return 0;
    });

    this.allCatalogs = this.data.allCatalogs;

    this.formGroup.get('costCentersFilterCtrl').valueChanges.subscribe((value: any) => {
      this.filterCostCenters();
    })*/


    this.errorMessages = getCatalogErrorMessages(this.variables);
  }

  getAllActiveTechs() {
    this.isLoadingTechs = true;

    this.TechnologiesManagementService.getAllActiveTechnologies().pipe(
      retryWhen(errors =>
        errors.pipe(
          scan((retryCount, error) => {
            if (retryCount >= 3) {
              throw error; // Exceeded retry attempts, propagate error
            }
            return retryCount + 1;
          }, 0),
          delay(2500) // Delay between retries (2.5 seconds)
        )
      ),
      catchError(err => {
        console.error('Error fetching techs:', err);
        this.errorDetected = true;

        const message = this.errorMessages[err.error.message]
        this.errorText = message ? message : this.variables.detectedError;

        return throwError(() => err);
      })
    ).subscribe({
      next: (data: any[]) => {
        try {
          this.allTechs = data;
        } catch (err) {
          console.error('Error processing data:', err);
          this.errorDetected = true;
          this.errorText = this.variables.detectedError;
        }
      },
      complete: () => {
        if (this.allTechs && !this.errorDetected) {
          this.isLoadingTechs = false;
          this.getCatalogById(this.local_data.data.catalogId);
        }
      }
    });
  }

  getCatalogById(id: string) {
    this.isLoadingCatalogs = true;
    this.catalogsService.getCatalogById(id).pipe(
      retryWhen(errors =>
        errors.pipe(
          scan((retryCount, error) => {
            if (retryCount >= 3) {
              throw error;
            }
            return retryCount + 1;
          }, 0),
          delay(2500) // Delay between retries (2.5 seconds)
        )
      ),
      catchError(err => {
        console.error('Error fetching techs:', err);
        this.errorDetected = true;

        const message = this.errorMessages[err.error.message]
        this.errorText = message ? message : this.variables.detectedError;

        return throwError(() => err);
      })
    ).subscribe({
      next: (data: any) => {
        try {
          this.local_data.data.techId = data.technologyId;
          this.local_data.data.name = data.name;
          this.local_data.data.state = data.state;
        } catch (err) {
          console.error('Error processing data:', err);
          this.errorDetected = true;
          this.errorText = this.variables.detectedError;
        }
      },
      complete: () => {
        if (this.allTechs && !this.errorDetected) {
          this.isLoadingCatalogs = false;

          this.formGroup = this._formBuilder.group({
            techCtrl: [this.local_data.data.techId, Validators.required],
            nameCtrl: [this.local_data.data.name, Validators.required],
          });
        }
      }
    });
  }




  filterCostCenters() {
    if (!this.costCenters) {
      return;
    }
    let search = this.formGroup.get('costCentersFilterCtrl').value;
    if (!search) {
      this.filteredCostCenters = (this.costCenters.slice());
      return;
    }
    else {
      search = search.toLowerCase();
    }

    this.filteredCostCenters = this.costCenters.filter((costCenters: any) => costCenters.toLowerCase().indexOf(search) > -1);

  }

  doAction() {
    const tech = this.formGroup.get('techCtrl')?.value;
    const name = this.formGroup.get('nameCtrl')?.value;
    const state = this.local_data.data.state;

    if (!state) {
      this.infoBar.showSnackbar(this.variables.detectedError, ['error-snackbar'], 4000);
      return;
    }

    if (this.formGroup.valid) {
      this.catalogsService.basicEditCatalog(this.local_data.data.catalogId, name, tech, state).subscribe

        ({
          next: (data) => {
            if (data) {
              this.dialogRef.close({ data: { success: true } });
            }
          },
          error: (error) => {
            console.error('Error:', error.error);

            const message = this.errorMessages[error.error.message]
            this.infoBar.showSnackbar(message, ['error-snackbar'], 4000);
          }
        });
    }

  }

  onCheckError(tech: any, name: any, region: any, costCenter: any) {
    if (!name) {
      this.invalidInput = true;
      this.errorMessage = this.variables.insertTechnologyNameMessage;
    }
    if (!tech) {
      this.invalidInput1 = true;
      this.errorMessage1 = this.variables.selectTech;
    }
    if (!region) {
      this.invalidInput2 = true;
      this.errorMessage2 = this.variables.selectRegion;
    }
    if (!costCenter) {
      this.invalidInput4 = true;
      this.errorMessage4 = this.variables.selectCostCenter;
    }
  }

  onChange() {
    this.invalidInput = false;
  }

}
